<div class="inner-content" ridangoAppTrapFocus>
    <div class="flex-align-center inset-0 !flex">
        <div
            class="flex-column flex h-auto w-full rounded-2xl bg-white dark:border-2 dark:border-solid dark:border-contrast-yellow">
            <!-- Header -->
            <div class="flex-align-center !flex justify-between border-solid p-4">
                <div class="flex-align-center flex w-6">
                    <!-- Empty space for alignment -->
                </div>
                <p class="font-semibold">
                    {{ 'REMOVE_CREDIT_CARD' | translate }}
                </p>
                <button class="pt-2" [attr.aria-label]="'CLOSE' | translate" (click)="dismiss()" mat-icon-button>
                    <mat-icon class="close-button font-bold">close</mat-icon>
                </button>
            </div>

            <!-- Content -->
            <div class="box-border flex-1 overflow-y-auto p-4">
                <p class="mb-4 text-left text-sm text-gray-700 dark:text-contrast-yellow">
                    {{ 'ARE_YOU_SURE_REMOVE_CARD' | translate }}
                </p>

                <!-- Card Display -->
                <div
                    class="mb-6 rounded-lg border border-gray-200 p-4 shadow-sm dark:border-2 dark:border-solid dark:border-contrast-yellow"
                    [attr.aria-label]="
                        (card.type === 'mastercard' ? 'Mastercard' : 'Visa') +
                        ('CARD_ENDING_IN' | translate) +
                        card.lastFourDigits +
                        ('EXPIRES_ON' | translate) +
                        card.expiryDate
                    "
                    role="group">
                    <div aria-hidden="true">
                        <p class="text-base font-bold leading-5 tracking-normal">
                            {{ card.type === 'mastercard' ? 'Mastercard' : 'Visa' }}
                        </p>
                        <p
                            class="text-base font-light leading-5 tracking-wide text-[#414141] dark:text-contrast-yellow">
                            •••• {{ card.lastFourDigits }} | {{ card.expiryDate }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- Action Buttons -->
            <div class="m-4 mt-0">
                <!-- Remove Button -->
                <button
                    class="modal-confirm-button bg-primary-danger mb-2 h-14 w-full rounded-lg font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                    (click)="confirm()">
                    {{ 'REMOVE_CREDIT_CARD' | translate }}
                </button>

                <!-- Cancel Button -->
                <ion-button
                    class="w-full"
                    [attr.aria-label]="'DONT_REMOVE_CREDIT_CARD' | translate"
                    (click)="dismiss()"
                    size="large"
                    fill="clear">
                    <ion-label class="var-app-light:text-primary text-base font-semibold normal-case">
                        {{ 'DONT_REMOVE_CREDIT_CARD' | translate }}
                    </ion-label>
                </ion-button>
            </div>
        </div>
    </div>
</div>
